import { z } from 'zod';
import { FocusAreaSummaryDisparity } from 'libs/end-to-end/src/summary';
import { TestSummary } from 'libs/end-to-end/src/tests-utils';
import { Insight } from 'libs/end-to-end/src/insights';
import { RootCauseGroupResult } from 'libs/end-to-end/src/root-cause-analysis';

export const BiasAnalysisOutput = z
  .object({
    focusAreaName: z.string(),
    testSummary: TestSummary,
    disparities: z.array(FocusAreaSummaryDisparity),
    insights: z.array(Insight),
    insightsForDeepDive: z.array(Insight),
    visualizations: z.array(RootCauseGroupResult),
    controlVars: z.array(z.string()).optional(),

    /**
     * @see BiasAnalysisExtras.treatmentDimensionLevel for more information on what
     * this field is used for.
     */
    treatmentDimensionLevel: z.string().optional(),
  })
  .describe('BiasAnalysisOutput');

export type BiasAnalysisOutput = z.infer<typeof BiasAnalysisOutput>;
